import React, { ReactNode } from 'react';
import { FormControl, FormGroup, FormLabel } from '@mui/material';

interface Props {
  readonly label: string;
  readonly children?: ReactNode;
}

export function PermissionCategory({ label, children }: Props) {
  return (
    <FormControl component="fieldset" sx={{ m: 3 }}>
      <FormLabel component="legend">{label}</FormLabel>
      <FormGroup>{children}</FormGroup>
    </FormControl>
  );
}
